import { createSlice } from "@reduxjs/toolkit";
import { newsService } from "../../services/siteContentService";
import { createCustomAsyncThunk, defaultEntityAdapter } from "../utils";


export const getSiteNews = createCustomAsyncThunk(
    "news/get",
    async params => await newsService.get(params)
)

const siteNewsSlice = createSlice({
    name: "siteNews",
    initialState: defaultEntityAdapter.getInitialState({
        count: 1,
        isLoading: true,
        error: null
    }),

    extraReducers: builder => {
        builder
            .addCase(getSiteNews.pending, state => { state.isLoading = true })
            .addCase(getSiteNews.fulfilled, (state, action) => {
                state.count = action.payload.count
                defaultEntityAdapter.setAll(state, action.payload.results)
                state.isLoading = false
            })
            .addCase(getSiteNews.rejected, (state, action) => {
                state.error = action.error
                state.isLoading = false
            })
    }
})

export const siteNewsSelector = defaultEntityAdapter.getSelectors(x => x.site.siteNews)

export default siteNewsSlice.reducer
